import React, { useState } from 'react';
import { Modal, Box } from '@mui/material';
import VerbruikInschatterBox from './VerbruikInschatterBox';

const VerbruikInschatter = ({
    modalOpen,
    handleModalClose,
    dubbeleMeter,
    teruglevering,
    entiteit,
    selectedBuildingType,
    setSelectedBuildingType,
    householdSize,
    sethouseholdSize,
    setReturnedEnergyAmount,
    returnedEnergyAmount,
    solarPanels,
    setSolarPanels,
    setIsFetchingData,
    setVerbruikEstimaterStep2Output,
    verbruikEstimaterStep2Output = { verbruikEstimaterStep2Output },
    setFinalChosenUsage = { setFinalChosenUsage },
    agentID

    
}) => {


    const [estimatedReturns, setEstimatedReturns] = useState({ high: 0, low: 0, single: 0 });
    const [isTerugleveringStep, setIsTerugleveringStep] = useState(false);

    const handleTerugleveringClick = () => {
        setIsTerugleveringStep(true);
        setStep(step + 1)
    };

    const [step, setStep] = useState(1); // Nieuwe stap stand voor de twee nieuwe stappen
    const handleNextStep = () => {
        if (step > 0) {
            setStep(step + 1); // Ga terug naar vorige stap
            let localStep = step + 1;
            if (entiteit === "Particulier" && localStep === 3) {
                if (teruglevering) {
                    setIsTerugleveringStep(true);
                }
            } else if (entiteit === "Zakelijk" && localStep === 2) {
                if (teruglevering) {
                    setIsTerugleveringStep(true);
                }
            }
        }
    };

    const handlePreviousStep = () => {
        if (step > 1) {

            setStep(step - 1); // Ga terug naar vorige stap
            console.log(step);
            console.log(isTerugleveringStep);
        }

        setIsTerugleveringStep(false);
    };

    const handleClose = () => {
        setIsTerugleveringStep(false); // Reset de stap bij het sluiten van de modal
        setStep(1);
        handleModalClose(); // Bel de oorspronkelijke handleModalClose die van buitenaf komt
    };



    const handleSaveEstimate = () => {
        setIsTerugleveringStep(false); // Reset de stap bij het sluiten van de modal
        setStep(1);

        if (teruglevering) {
            setReturnedEnergyAmount({
                ...returnedEnergyAmount,
                return_high: estimatedReturns.high.toString(),
                return_low: estimatedReturns.low.toString(),
                return: estimatedReturns.single.toString(),
            });
        }

        if (dubbeleMeter) {
            setVerbruikEstimaterStep2Output(prevValues => ({
                ...prevValues,
                e_high: verbruikEstimaterStep2Output.e_high,
                e_low: verbruikEstimaterStep2Output.e_low,
            }));
            setFinalChosenUsage({
                e_high: verbruikEstimaterStep2Output.e_high,
                e_low: verbruikEstimaterStep2Output.e_low
            });
        } else {
            setVerbruikEstimaterStep2Output(prevValues => ({
                ...prevValues,
                e_single: verbruikEstimaterStep2Output.e_single,
            }))
            setFinalChosenUsage({
                e_single: verbruikEstimaterStep2Output.e_single
            });
        }

        handleModalClose();
    };


    // based on the entiteit and teruglevering, calculate the number of steps. Use this for the navigation.
    var pathSteps = 1;
    if (entiteit == "Zakelijk") {
        pathSteps = 1;
    } else if (entiteit == "Particulier") {
        pathSteps = 2;
    }

    if (teruglevering) {
        pathSteps = pathSteps + 1;
    }

    const getNavigationDiv = () => {
        // if step == 1, we need to show the Annuleren link. Otherwise, it should be the Vorige link
        // We don't use buttons buttons but a hrefs.
        // If step === pathSteps, show the "Gebruik Schatting" link
        // if step !== pathSteps, show the "Volgende" link.
        return (
            <div className="navigation">
                {step ===1 && (
                    <a href="#" onClick={handleModalClose}>Annuleren</a>
                )}
                {step > 1 && (
                    <a href="#" onClick={handlePreviousStep}>Vorige</a>
                )}
                {step === pathSteps && (
                    <a href="#" onClick={handleSaveEstimate} className='btn btn-primary'>Gebruik Schatting</a>
                )}
                {step !== pathSteps && (
                    <a href="#" onClick={handleNextStep} className='btn btn-primary'>Volgende</a>
                )}
            </div>
        )
    }

            



    return (
        <Modal open={modalOpen} onClose={handleClose}>
            <Box className="verbruik-inschatting">
                <div
                    className="icon-as-close icon-size closeButton"
                    onClick={handleModalClose}
                    style={{ position: 'absolute', right: '10px', top: '10px', cursor: 'pointer', width: '2rem', height: '2rem' }}
                ></div>
                <VerbruikInschatterBox
                    dubbeleMeter={dubbeleMeter}
                    entiteit={entiteit}
                    teruglevering={teruglevering}
                    handleModalClose={handleModalClose}
                    selectedBuildingType={selectedBuildingType}
                    setSelectedBuildingType={setSelectedBuildingType}
                    householdSize={householdSize}
                    sethouseholdSize={sethouseholdSize}
                    setReturnedEnergyAmount={setReturnedEnergyAmount}
                    returnedEnergyAmount={returnedEnergyAmount}
                    estimatedReturns={estimatedReturns}
                    setEstimatedReturns={setEstimatedReturns}
                    solarPanels={solarPanels}
                    setSolarPanels={setSolarPanels}
                    setIsFetchingData={setIsFetchingData}
                    setVerbruikEstimaterStep2Output={setVerbruikEstimaterStep2Output}
                    isTerugleveringStep={isTerugleveringStep}
                    setIsTerugleveringStep={setIsTerugleveringStep}
                    step={step}
                    agentID={agentID}
                />
                {getNavigationDiv()}
                {/* <div className="navigation">
                    {step === 1 && (
                        <a onClick={handleClose}>Annuleren</a>
                    )}
                    {step > 1 && (
                        <a onClick={handlePreviousStep}>Vorige</a>
                    )}
                    {step === 1 && !isTerugleveringStep && (
                        <a onClick={handleNextStep} className='btn btn-primary'>Volgende</a>
                    )}
                    {teruglevering && step === 2 && !isTerugleveringStep && (
                        <a onClick={handleTerugleveringClick} className='btn btn-primary'>Teruglevering inschatten</a>
                    )}
                    {(step === 2 && !teruglevering) && (
                        <a onClick={handleSaveEstimate} className='btn btn-primary'>Gebruik schatting</a>
                    )}

                    {step === 3 && (
                        <a onClick={handleSaveEstimate} className='btn btn-primary'>Gebruik schatting</a>
                    )}

                </div> */}
            </Box>
        </Modal>
    );
}

VerbruikInschatter.displayName = 'VerbruikInschatter';
export default VerbruikInschatter;